import { computed }   from 'mobx';
import { Model }      from '@mathquis/modelx';
import currentSession from './currentSession';

class Rights extends Model {
  @computed
  get for() {
    return {
      advertiser: {
        add: currentSession.isAdmin,
        delete: currentSession.isAdmin,
        edit: currentSession.isAdmin,
        list: currentSession.isAdmin,
      },
      demand: {
        delete: currentSession.isAdminOrSupport,
        export: currentSession.isAdminOrSupport || currentSession.isOrganizer,
        newStatus: currentSession.isAdminOrSupport || currentSession.isOrganizer,
      },
      demandConfig: {
        edit: currentSession.isAdmin || currentSession.isOrganizer,
      },
      demandMessage: {
        add:
          currentSession.isAdminOrSupport ||
          currentSession.isSecurityOfficer ||
          currentSession.isOrganizer ||
          currentSession.isStandist,
      },
      layoutType: {
        add: currentSession.isAdmin,
        delete: currentSession.isAdmin,
        edit: currentSession.isAdmin,
        list:
          currentSession.isAdminOrSupport ||
          currentSession.isOrganizer,
      },
      mountingAttestation: {
        add: currentSession.isAdminOrSupport || currentSession.isOrganizer || currentSession.isSecurityOfficer,
        zip: currentSession.isAdminOrSupport || currentSession.isOrganizer || currentSession.isSecurityOfficer,
      },
      notification: {
        add:
          currentSession.isAdminOrSupport ||
          currentSession.isCoordinatorSps ||
          currentSession.isOrganizer,
      },
      provider: {
        add: currentSession.isAdmin,
        delete: currentSession.isAdmin,
        edit: currentSession.isAdmin,
        list: currentSession.isAdmin,
      },
      report: {
        add: currentSession.isAdminOrSupport,
        editOrClose: currentSession.isAdminOrSupport,
      },
      show: {
        edit: currentSession.isAdmin || currentSession.isOrganizer,
        list: currentSession.isAdmin,
        view: currentSession.isAdmin || currentSession.isOrganizer,
      },
      source: {
        add: currentSession.isAdmin,
        delete: currentSession.isAdmin,
        edit: currentSession.isAdmin,
        list: currentSession.isAdmin,
      },
      stand: {
        add: currentSession.isAdminOrSupport || currentSession.isOrganizer,
        delete: currentSession.isAdminOrSupport || currentSession.isOrganizer,
        edit: currentSession.isAdminOrSupport || currentSession.isOrganizer,
        export: currentSession.isAdminOrSupport || currentSession.isSecurityOfficer || currentSession.isOrganizer,
        import: currentSession.isAdmin || currentSession.isOrganizer,
        markAsTreated: currentSession.isAdminOrSupport || currentSession.isOrganizer,
        newStatus: {
          pendingPlansConfirmation: currentSession.isAdminOrSupport,
          pendingPlansVerification: true,
          validatedPlans:
            currentSession.isAdminOrSupport ||
            currentSession.isOrganizer ||
            currentSession.isStandist,
          waitingForPlans: currentSession.isAdminOrSupport,
        },
      },
      standDocumentMedia: {
        delete:
          currentSession.isAdminOrSupport ||
          currentSession.isSecurityOfficer ||
          currentSession.isOrganizer,
        newStatus:
          currentSession.isAdminOrSupport ||
          currentSession.isSecurityOfficer ||
          currentSession.isOrganizer,
        zip:
          currentSession.isAdminOrSupport ||
          currentSession.isSecurityOfficer ||
          currentSession.isOrganizer,
      },
      standDocumentMessage: {
        add:
          currentSession.isAdminOrSupport ||
          currentSession.isSecurityOfficer ||
          currentSession.isOrganizer ||
          currentSession.isStandist,
      },
      standLayout: {
        add: currentSession.isAdminOrSupport || currentSession.isSecurityOfficer || currentSession.isOrganizer,
        delete: currentSession.isAdminOrSupport || currentSession.isSecurityOfficer || currentSession.isOrganizer,
        edit: currentSession.isAdminOrSupport || currentSession.isSecurityOfficer || currentSession.isOrganizer,
      },
      standMedia: {
        delete: currentSession.isAdminOrSupport || currentSession.isOrganizer,
      },
      standMessage: {
        add:
          currentSession.isAdminOrSupport ||
          currentSession.isCoordinatorSps ||
          currentSession.isSecurityOfficer ||
          currentSession.isExhibitionCenterService ||
          currentSession.isOrganizer ||
          currentSession.isStandist,
      },
      standsSecurityAttestation: {
        zip:
          currentSession.isAdmin || currentSession.isCoordinatorSps || currentSession.isOrganizer,
      },
      user: {
        list: currentSession.isAdmin,
      },
      userStandRole: {
        add: currentSession.isAdminOrSupport || currentSession.isOrganizer || currentSession.isStandist,
        delete: currentSession.isAdminOrSupport || currentSession.isOrganizer,
        edit: currentSession.isAdminOrSupport || currentSession.isOrganizer,
      },
    };
  }
}

export default new Rights();
